import { render } from "./ResumoSequencia.vue?vue&type=template&id=833a5922&scoped=true"
import script from "./ResumoSequencia.vue?vue&type=script&lang=js"
export * from "./ResumoSequencia.vue?vue&type=script&lang=js"

import "./ResumoSequencia.vue?vue&type=style&index=0&id=833a5922&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833a5922"]])

export default __exports__